// Helpers for turning the reading-link checkbox selection into the payload
// sent to /lti13/resource_selection.get_resource_jwt/.
//
// A selected reading link is identified by `${nodeId}::${courseOrderIdx}::${linkOrderIdx}`.
// Two connected courses (e.g. children of the same master) can share docbook
// node ids, so the node id alone is NOT enough to know which course a link
// belongs to -- the course index from the selection key is authoritative.

export const SELECTION_SEPARATOR = '::'

export const readingSelectionKey = (nodeId, courseOrderIdx, linkOrderIdx) =>
  [nodeId, courseOrderIdx, linkOrderIdx].join(SELECTION_SEPARATOR)

// DOM id for a reading checkbox, namespaced by course so that the same node id
// in two courses does not produce duplicate element ids (which would make a
// <label htmlFor> toggle the other course's checkbox). Uses the same '::'
// separator as the selection key: it cannot appear in a coursenum or node id,
// so 'reading::12-fall::sect' and 'reading::12::fall-sect' stay distinct.
export const readingCheckboxId = (coursenum, nodeId) =>
  ['reading', coursenum, nodeId].join(SELECTION_SEPARATOR)

export const buildReadingNodes = (selectedReadingIds, connectedCourses) => {
  const nodes = []
  for (const targetId of selectedReadingIds) {
    const [readingId, courseOrderIdx, linkOrderIdx] =
      targetId.split(SELECTION_SEPARATOR)
    const course = connectedCourses[Number(courseOrderIdx)]
    const node = course && course.nodeMap ? course.nodeMap[readingId] : null
    if (!node) {
      continue
    }
    nodes.push({
      ...node,
      coursenum: course.coursenum,
      courseOrderIdx,
      linkOrderIdx,
    })
  }
  return nodes
}
